import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { FloatingCTA } from './components/FloatingCTA';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { ProblemSection } from './components/ProblemSection';
import { ProductSection } from './components/ProductSection';
import { PricingSection } from './components/PricingSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-offwhite font-sans selection:bg-sage selection:text-white relative" data-id="element-0">
      <CountdownBar data-id="element-1" />

      <main className="overflow-x-hidden" data-id="element-2">
        <HeroSection data-id="element-3" />
        <HookSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <ProductSection data-id="element-6" />
        <PricingSection data-id="element-7" />
        <SocialProofSection data-id="element-8" />
        <FAQSection data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
      <FloatingCTA data-id="element-11" />
    </div>;
}